import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  container: {

  },
  title: {
    color: '#2e2e2e'
  }
}));